export default "__VITE_ASSET__IATjfIdq__"